import { NgStyle } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MenuItem } from 'src/app/_core';
import { ThemeBaseComponent } from 'src/app/_core/bases/theme-base.component';
import { IconButtonComponent } from '../../../icon-button/icon-button.component';
import { NavbarService } from '../../state/navbar.service';

@Component({
  standalone: true,
  selector: 'neopos-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgStyle,
    RouterLink,
    RouterLinkActive,
    TranslateModule,
    IconButtonComponent,
  ],
})
export class MobileMenuComponent extends ThemeBaseComponent {
  readonly navbarService = inject(NavbarService);

  menuItems = input.required<MenuItem[]>();

  menuItemClick = output<void>();
}
